enum TrayStatusEnum {
  Pending = 'Pending',
  Active = 'Active',
  Complete = 'Complete',
}

export default TrayStatusEnum;
